import CorporateCardStartupLarge from 'assets/images/corporate-card/corporate-card-startup-large.png'
import CorporateCardStartupMedium from 'assets/images/corporate-card/corporate-card-startup-medium.png'
import CorporateCardStartupSmall from 'assets/images/corporate-card/corporate-card-startup-small.png'

interface GetPreloadImagesProps {
  isMobile: boolean
  isTablet: boolean
}

export const getPreloadImages = ({
  isMobile,
  isTablet,
}: GetPreloadImagesProps) => {
  if (isMobile) {
    return [CorporateCardStartupSmall]
  }

  if (isTablet) {
    return [CorporateCardStartupMedium]
  }

  return [CorporateCardStartupLarge]
}
